module.exports = __webpack_public_path__ + "img/181.bd659c4d.jpg";